<div class="dcp">
    <div class="header">
        @if (data?.item?.type == 'revert_prescription') {
        <!-- Revert Prescription Confirmation -->
        <h2>You are about to revert this prescription. Once reverted, it will appear in the <br> ‘Unmatched fax queue’
            listing inside Pillway. Do you want to continue?</h2>
        } @else {
        <!-- Confirm Prescription Confirmation -->
        <h2>Are you sure you want to confirm this change?</h2>
        }
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2">
            <button class="custom-btn" [disabled]="isRevert || isLoading" (click)="closeDialog()"
                mat-dialog-close>Cancel</button>
            @if(data?.item?.type == 'revert_prescription'){
            @if(data?.item?.client_id == 37){
            <!-- Revert Prescription Confirmation -->
            <button class="btn btn-outline-primary" [disabled]="isRevert" (click)="confirmRevertSelection()">{{ isRevert
                ?
                "Reverting..." : "Confirm" }}</button>
            }
            <!-- Revert Dialogue Prescription Confirmation -->
            @else if(data?.item?.client_id == 36){
            <button class="btn btn-outline-primary" [disabled]="isRevert" (click)="confirmRevertDialogueSelection()">
                {{ isRevert ? "Reverting..." : "Confirm" }}</button>
            }
            } @else {
            @if(data?.item?.client_id == 37){
            <!-- Confirm Prescription Confirmation -->
            <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="confirmSelection()">
                {{ isLoading ? "Confirming..." : "Confirm" }}</button>
            } @else if(data?.item?.client_id == 36){
            <!-- Confirm Dialogue Prescription Confirmation -->
            <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="confirmDiaPrescription()">
                {{ isLoading ? "Confirming..." : "Confirm" }}</button>
            }
            }
        </div>
    </div>
</div>